// Auto-generated from your public/wallet-logos folder listing.
// Display names are guessed from the filename - rename any that look off,
// this is just a plain array.
const WALLETS = [
  { id: '1inch', name: '1inch', icon: '/wallet-logos/1inch.png' },
  { id: 'aktionariat', name: 'Aktionariat', icon: '/wallet-logos/aktionariat.png' },
  { id: 'alice', name: 'Alice', icon: '/wallet-logos/alice.png' },
  { id: 'alphawallet', name: 'Alphawallet', icon: '/wallet-logos/alphawallet.png' },
  { id: 'argent', name: 'Argent', icon: '/wallet-logos/argent.png' },
  { id: 'atoken', name: 'Atoken', icon: '/wallet-logos/atoken.png' },
  { id: 'atomic', name: 'Atomic', icon: '/wallet-logos/atomic.png' },
  { id: 'atwallet', name: 'Atwallet', icon: '/wallet-logos/atwallet.png' },
  { id: 'authereum', name: 'Authereum', icon: '/wallet-logos/authereum.png' },
  { id: 'banksocial', name: 'Banksocial', icon: '/wallet-logos/banksocial.png' },
  { id: 'bifrost', name: 'Bifrost', icon: '/wallet-logos/bifrost.jpg' },
  { id: 'binance', name: 'Binance', icon: '/wallet-logos/binance.png' },
  { id: 'bitget', name: 'Bitget', icon: '/wallet-logos/bitget.png' },
  { id: 'bitkeep', name: 'Bitkeep', icon: '/wallet-logos/bitkeep.png' },
  { id: 'bitpay', name: 'Bitpay', icon: '/wallet-logos/bitpay.jpg' },
  { id: 'bitverse', name: 'Bitverse', icon: '/wallet-logos/bitverse.png' },
  { id: 'blockchain', name: 'Blockchain', icon: '/wallet-logos/blockchain.png' },
  { id: 'bravelogo', name: 'Bravelogo', icon: '/wallet-logos/bravelogo.avif' },
  { id: 'bridge', name: 'Bridge', icon: '/wallet-logos/bridge.png' },
  { id: 'brise', name: 'Brise', icon: '/wallet-logos/brise.jpg' },
  { id: 'coin98', name: 'Coin98', icon: '/wallet-logos/coin98.jpg' },
  { id: 'coinomi', name: 'Coinomi', icon: '/wallet-logos/coinomi.png' },
  { id: 'coolwallet', name: 'Coolwallet', icon: '/wallet-logos/coolwallet.png' },
  { id: 'crypto-com', name: 'Crypto Com', icon: '/wallet-logos/crypto-com.png' },
  { id: 'cybavo', name: 'Cybavo', icon: '/wallet-logos/cybavo.jpg' },
  { id: 'dcent', name: 'Dcent', icon: '/wallet-logos/dcent.png' },
  { id: 'defiant', name: 'Defiant', icon: '/wallet-logos/defiant.jpg' },
  { id: 'dharma', name: 'Dharma', icon: '/wallet-logos/dharma.png' },
  { id: 'dok', name: 'Dok', icon: '/wallet-logos/dok.png' },
  { id: 'easypocket', name: 'Easypocket', icon: '/wallet-logos/easypocket.jpg' },
  { id: 'eidoo', name: 'Eidoo', icon: '/wallet-logos/eidoo.png' },
  { id: 'ellipal', name: 'Ellipal', icon: '/wallet-logos/ellipal.png' },
  { id: 'enjin', name: 'Enjin', icon: '/wallet-logos/enjin.webp' },
  { id: 'equal', name: 'Equal', icon: '/wallet-logos/equal.jpg' },
  { id: 'exodus', name: 'Exodus', icon: '/wallet-logos/exodus.jpg' },
  { id: 'fetchai', name: 'Fetchai', icon: '/wallet-logos/fetchai.jpg' },
  { id: 'flare', name: 'Flare', icon: '/wallet-logos/flare.jpg' },
  { id: 'fox', name: 'Fox', icon: '/wallet-logos/fox.jpg' },
  { id: 'frontier', name: 'Frontier', icon: '/wallet-logos/frontier.jpg' },
  { id: 'gateweb3', name: 'Gateweb3', icon: '/wallet-logos/gateweb3.png' },
  { id: 'gnosis', name: 'Gnosis', icon: '/wallet-logos/gnosis.jpg' },
  { id: 'gridplus', name: 'Gridplus', icon: '/wallet-logos/gridplus.png' },
  { id: 'grove', name: 'Grove', icon: '/wallet-logos/grove.webp' },
  { id: 'guarda', name: 'Guarda', icon: '/wallet-logos/guarda.jpg' },
  { id: 'halodefi', name: 'Halodefi', icon: '/wallet-logos/halodefi.png' },
  { id: 'hashkey', name: 'Hashkey', icon: '/wallet-logos/hashkey.png' },
  { id: 'hashpack', name: 'Hashpack', icon: '/wallet-logos/hashpack.jpg' },
  { id: 'huobi', name: 'Huobi', icon: '/wallet-logos/huobi.png' },
  { id: 'imtoken', name: 'Imtoken', icon: '/wallet-logos/imtoken.png' },
  { id: 'infinito', name: 'Infinito', icon: '/wallet-logos/infinito.webp' },
  { id: 'infinity', name: 'Infinity', icon: '/wallet-logos/infinity.png' },
  { id: 'jade', name: 'Jade', icon: '/wallet-logos/jade.png' },
  { id: 'keplr', name: 'Keplr', icon: '/wallet-logos/keplr.png' },
  { id: 'keyring', name: 'Keyring', icon: '/wallet-logos/keyring.svg' },
  { id: 'kybersnap', name: 'Kybersnap', icon: '/wallet-logos/kybersnap.png' },
  { id: 'ledger', name: 'Ledger Wallet', icon: '/wallet-logos/ledger.png' },
  { id: 'looprings', name: 'Looprings', icon: '/wallet-logos/loopring.png' },
  { id: 'mathwallet', name: 'Mathwallet', icon: '/wallet-logos/mathwallet.jpg' },
  { id: 'meetone', name: 'Meetone', icon: '/wallet-logos/meetone.jpg' },
  { id: 'metamask', name: 'MetaMask', icon: '/wallet-logos/metamask.png' },
  { id: 'mew', name: 'Mew', icon: '/wallet-logos/mew.png' },
  { id: 'midas', name: 'Midas', icon: '/wallet-logos/midas.png' },
  { id: 'morix', name: 'Morix', icon: '/wallet-logos/morix.png' },
  { id: 'mykey', name: 'Mykey', icon: '/wallet-logos/mykey.png' },
  { id: 'nash', name: 'Nash', icon: '/wallet-logos/nash.jpg' },
  { id: 'nova', name: 'Nova', icon: '/wallet-logos/nova.jpg' },
  { id: 'o3wallet', name: 'O3wallet', icon: '/wallet-logos/o3wallet.jpg' },
  { id: 'onto', name: 'Onto', icon: '/wallet-logos/onto.png' },
  { id: 'ownbit', name: 'Ownbit', icon: '/wallet-logos/ownbit.png' },
  { id: 'oxen', name: 'Oxen', icon: '/wallet-logos/oxen.png' },
  { id: 'peakdefi', name: 'Peakdefi', icon: '/wallet-logos/peakdefi.jpg' },
  { id: 'phantom', name: 'Phantom', icon: '/wallet-logos/phantom.jpg'},
  { id: 'pillar', name: 'Pillar', icon: '/wallet-logos/pillar.png' },
  { id: 'plasmapay', name: 'Plasmapay', icon: '/wallet-logos/plasmapay.jpg' },
  { id: 'polkadot', name: 'Polkadot', icon: '/wallet-logos/polkadot.png' },
  { id: 'rabby', name: 'Rabby', icon: '/wallet-logos/rabby.jpg' },
  { id: 'rainbow', name: 'Rainbow', icon: '/wallet-logos/rainbow.jpg' },
  { id: 'robinhood', name: 'Robinhood', icon: '/wallet-logos/robinhood.jpg' },
  { id: 'ronin', name: 'Ronin', icon: '/wallet-logos/ronin.jpg' },
  { id: 'rwallet', name: 'Rwallet', icon: '/wallet-logos/rwallet.png' },
  { id: 'safemoon', name: 'Safemoon', icon: '/wallet-logos/safemoon.jpg' },
  { id: 'safepal', name: 'Safepal', icon: '/wallet-logos/safepal.svg' },
  { id: 'saitapro', name: 'Saitapro', icon: '/wallet-logos/saitapro.jpg' },
  { id: 'shido', name: 'Shido', icon: '/wallet-logos/shido.png' },
  { id: 'solace', name: 'Solace', icon: '/wallet-logos/solace.jpg' },
  { id: 'soflare', name: 'Soflare', icon: '/wallet-logos/soflare.png' },
  { id: 'sparkpoint', name: 'Sparkpoint', icon: '/wallet-logos/sparkpoint.png' },
  { id: 'spatium', name: 'Spatium', icon: '/wallet-logos/spatium.png' },
  { id: 'talken', name: 'Talken', icon: '/wallet-logos/talken.jpg' },
  { id: 'tokenary', name: 'Tokenary', icon: '/wallet-logos/tokenary.png' },
  { id: 'tokenpocket', name: 'Tokenpocket', icon: '/wallet-logos/tokenpocket.png' },
  { id: 'tongue', name: 'Tongue', icon: '/wallet-logos/tongue.jpg' },
  { id: 'torus', name: 'Torus', icon: '/wallet-logos/torus.jpg' },
  { id: 'trezor', name: 'Trezor', icon: '/wallet-logos/trezor.png' },
  { id: 'trust', name: 'Trust', icon: '/wallet-logos/trust.jpg' },
  { id: 'trustee', name: 'Trustee', icon: '/wallet-logos/trustee.png' },
  { id: 'trustvault', name: 'Trustvault', icon: '/wallet-logos/trustvault.jpg' },
  { id: 'uniswap', name: 'Uniswap', icon: '/wallet-logos/uniswap.jpg' },
  { id: 'unstoppable', name: 'Unstoppable', icon: '/wallet-logos/unstoppable.jpg' },
  { id: 'venly', name: 'Venly', icon: '/wallet-logos/venly.jpg' },
  { id: 'viawallet', name: 'Viawallet', icon: '/wallet-logos/viawallet.jpg' },
  { id: 'vision', name: 'Vision', icon: '/wallet-logos/vision.jpg' },
  { id: 'wallet-io', name: 'Wallet io', icon: '/wallet-logos/wallet-io.jpg' },
  { id: 'walleth', name: 'Walleth', icon: '/wallet-logos/walleth.png' },
  { id: 'xinfin', name: 'Xinfin', icon: '/wallet-logos/xinfin.png' },
  { id: 'xaman', name: 'Xaman', icon: '/wallet-logos/xumm.jpg' },
  { id: 'zelcore', name: 'Zelcore', icon: '/wallet-logos/zelcore.png' },
  { id: 'zerion', name: 'Zerion', icon: '/wallet-logos/zerion.png' },
];

export default WALLETS;